<template>
  <section class="for_whom__container">
    <h2>Для кого разработан Coverse?</h2>

    <div class="for_whom__grid">
      <grid :items="grid" />
    </div>
  </section>
</template>

<script>
import Grid from "@/components/main/partials/Grid";

export default {
  name: 'ForWhom',
  components: {
    Grid,
  },
  data() {
    return {
      grid: [{
        icon: '/images/v4/svg/icon-marketers.svg',
        title: 'Маркетологи',
        text: 'Согласовывайте операционные данные и&nbsp;концепции без нескончаемых цепочек писем&nbsp;и диалогов в мессенджерах.',
      }, {
        icon: '/images/v4/svg/icon-project-managers.svg',
        title: 'Проектные менеджеры',
        text: 'Следите за статусом задач прямо в документе, назначайте ответственных в комментариях, ставьте задачи — сокращая время встреч на&nbsp;30%.',
      }, {
        icon: '/images/v4/svg/icon-product-managers.svg',
        title: 'Продакт-менеджеры',
        text: 'Управляйте работой над прототипом с помощью задач прямо в документе. Ускоряйте&nbsp;работу с гипотезами, собирая эксперименты в интерактивной таблице.',
      }, {
        icon: '/images/v4/svg/icon-advertising-specialists.svg',
        title: 'Рекламные специалисты',
        text: 'Согласовывайте концепты, креативы, бюджеты и отчеты по кампаниям в одном месте. Вносите правки и комментируйте в реальном времени — без бесконечной переписки.',
      }, {
        icon: '/images/v4/svg/icon-financial-managers.svg',
        title: 'Финансовые менеджеры',
        text: 'Управляйте расчетами, отчетами и прогнозами в таблицах. Согласовывайте данные с командой в реальном времени и&nbsp;следите за изменениями.',
      }, {
        icon: '/images/v4/svg/icon-lawyers.svg',
        title: 'Юристы',
        text: 'Ведите юридическую документацию в едином облачном пространстве. Комментируйте и редактируйте в реальном времени без множества редакций.',
      }],
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/breakpoints";

.for_whom__container {
  margin: 0 0 90px;

  h2 {
    font-size: 40px;
    font-weight: 700;
    line-height: 40px;
    text-align: center;
    margin: 0 0 72px;
  }

  .for_whom__grid {
    max-width: 1000px;
    margin: 0 auto;
  }
}

@include media-breakpoint-down($size-tablet) {
  .for_whom__container {
    margin: 0 0 70px;

    h2 {
      font-size: 34px;
      margin: 0 0 38px;
    }

    .for_whom__grid {
      max-width: 500px;
      margin: 0 auto;
    }
  }
}

@include media-breakpoint-down($size-mobile) {
  .for_whom__container {
    padding: 0 20px;
    margin: 0 0 57px;

    h2 {
      font-size: 24px;
      line-height: 34px;
      margin: 0 0 29px;
    }

    .for_whom__grid {
      max-width: 100%;
      margin: 0 auto;
    }
  }
}
</style>
